import React, { useState } from 'react';
import { Keyboard } from 'lucide-react';

interface ManualTicketEntryProps {
  onSubmit: (ticketCode: string) => void;
  isLoading: boolean;
}

export const ManualTicketEntry: React.FC<ManualTicketEntryProps> = ({ onSubmit, isLoading }) => {
  const [ticketCode, setTicketCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (ticketCode.trim()) {
      onSubmit(ticketCode.trim().toUpperCase());
    }
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <div className="flex items-center mb-4">
        <Keyboard className="h-5 w-5 text-gray-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-700">Manual Entry</h3>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="ticketCode" className="block text-sm font-medium text-gray-700 mb-1">
            Ticket Code
          </label>
          <input
            type="text"
            id="ticketCode"
            value={ticketCode}
            onChange={(e) => setTicketCode(e.target.value.toUpperCase())}
            placeholder="ABC12345"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            maxLength={8}
            pattern="[A-Z0-9]{8}"
            required
            disabled={isLoading}
          />
          <p className="text-xs text-gray-500 mt-1">Enter the 8-character ticket code</p>
        </div>
        
        <button
          type="submit"
          disabled={isLoading || !ticketCode.trim()}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Checking...' : 'Check In'}
        </button>
      </form>
    </div>
  );
};